
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as endlk_45Tqf0A0e7L3rTsvIIPBbYAAd6pIaIH0c7PpJ1_EMAMeta } from "/home/runner/work/evaluation/evaluation/pages/end.vue?macro=true";
import { default as tip_458GfAc44E8OQsEFfbyqkUwmrkrQKs7arn4j5c0X5h5oMeta } from "/home/runner/work/evaluation/evaluation/pages/tip.vue?macro=true";
import { default as indexaa6vdIkytUiX_45viZvDS3TC_45y7TIhq_45RWTmNlq3pVgCQMeta } from "/home/runner/work/evaluation/evaluation/pages/index.vue?macro=true";
import { default as modulewTQGP_TqddEDRddxMTON_4vxL2M1A6QZOYrhTLGkdnoMeta } from "/home/runner/work/evaluation/evaluation/pages/module.vue?macro=true";
import { default as prepare1VWg_45_yd5E6RPHV23fKK3MpELx35QizcFKCEKf_lYRAMeta } from "/home/runner/work/evaluation/evaluation/pages/prepare.vue?macro=true";
import { default as indexNREUL4y5Xq5J0IyNgnN7NiuQkXqbmvZUmdELHq5y7n4Meta } from "/home/runner/work/evaluation/evaluation/pages/map/index.vue?macro=true";
import { default as _91id_93ww25SZXS7e5HzaVezVvw8u55ZnnRaxwnalZgjbMyuJ8Meta } from "/home/runner/work/evaluation/evaluation/pages/user/[id].vue?macro=true";
import { default as index6v4AQf5ROE1xF6jWysIfbL91HGxDDrIxgaL4doUvQ9kMeta } from "/home/runner/work/evaluation/evaluation/pages/chat/index.vue?macro=true";
import { default as indexe1wGZiJCB2HBCRTycUlz1FgcOIG9xQ0gvlfzZ9PDb_45oMeta } from "/home/runner/work/evaluation/evaluation/pages/user/index.vue?macro=true";
import { default as _91id_93YDIAzHlUNipwwUWhVJ3OkRYqASZcLAikHpD9RiPY8aUMeta } from "/home/runner/work/evaluation/evaluation/pages/result/[id].vue?macro=true";
import { default as unauthorizeds3kqn5Zuz6VA8sWyMDBTxnX_458eQSEpUAaYXiJE7lUb8Meta } from "/home/runner/work/evaluation/evaluation/pages/unauthorized.vue?macro=true";
import { default as indexJsYoMaYBJYH48cXQtMXkEg6mny4MorHIBUXwVEZ_45jC4Meta } from "/home/runner/work/evaluation/evaluation/pages/reading/index.vue?macro=true";
import { default as password3GRTERY71KL2rLyszMU_45ARSN_45O36rF_45OLdN5vn1AzLUMeta } from "/home/runner/work/evaluation/evaluation/pages/user/password.vue?macro=true";
import { default as module_45previewE1ytUfGM65kgmDf_45r4gf0249lUHs9GpQGvYGhbHHSTUMeta } from "/home/runner/work/evaluation/evaluation/pages/module-preview.vue?macro=true";
import { default as indexZEBdhAvG6E70vKxmGeDCEmT0Gpm2HtznYSFO9UjBWGwMeta } from "/home/runner/work/evaluation/evaluation/pages/practice/index.vue?macro=true";
import { default as index_lOpMhQpRr7AkoGhY3UMVFfHNrvD5av2PVj6gHHOjEYMeta } from "/home/runner/work/evaluation/evaluation/pages/knowledge/index.vue?macro=true";
import { default as resumeF2OZkZ28YmcydvzQrrXYiSLG56ImIbBv_dNRHmDzJ5kMeta } from "/home/runner/work/evaluation/evaluation/pages/information/index/resume.vue?macro=true";
import { default as confirmw9sf3Ip2RJoBv6vbGjKYvDFm3UbcA8mKX_t3ASMMcaIMeta } from "/home/runner/work/evaluation/evaluation/pages/information/index/confirm.vue?macro=true";
import { default as positionp9agS2eni5LyK_45wRmZ726okQxmFBZ0wQZ3M4ZqvDTPgMeta } from "/home/runner/work/evaluation/evaluation/pages/information/index/position.vue?macro=true";
import { default as inspectionaJlHB6vgf_z8yAH7TpZnCcQ44JqWVsYq_VH3E_45J0bWgMeta } from "/home/runner/work/evaluation/evaluation/pages/information/index/inspection.vue?macro=true";
import { default as indexXYLZjTbYYNXu346ubMUxeQMcLg4xpMwIrhJzk1JYYrUMeta } from "/home/runner/work/evaluation/evaluation/pages/information/index.vue?macro=true";
import { default as _91id_933T5M6eXboOeypgbJnFzfAxFZTTLgDO59LDAxyjQjtt0Meta } from "/home/runner/work/evaluation/evaluation/pages/user/feedback/[id].vue?macro=true";
import { default as _91id_93pdXzOuxfUxxf27rW9KeOwIPHgWJ7a8ldn57IyihaKzQMeta } from "/home/runner/work/evaluation/evaluation/pages/practice-topic/[id].vue?macro=true";
import { default as _91id_93v4cMIHmGR14MIGnVF2VhlTXz97iSSEinuDgJo5vFc1cMeta } from "/home/runner/work/evaluation/evaluation/pages/result/complete/[id].vue?macro=true";
import { default as indexdl2JVfda45Gp_kdQvsynAQxSRevbFMPa2oDj_qab90MMeta } from "/home/runner/work/evaluation/evaluation/pages/performanceInterview/index.vue?macro=true";
import { default as index6h3bDbaF2n_LMb6vsXInS69gOBHqsCPdZF_eBYtxahwMeta } from "/home/runner/work/evaluation/evaluation/pages/potential-evaluations/index.vue?macro=true";
import { default as index99Xs9evpz_45hRKASPD7MnzWj38fCtx9NYAsmdUHw8uYwMeta } from "/home/runner/work/evaluation/evaluation/pages/crossPostingExperience/index.vue?macro=true";
import { default as indexJqZYadFjtj7yabn3qdTle6WRTeTnsUwgMhK_45dmrmraEMeta } from "/home/runner/work/evaluation/evaluation/pages/personal-development-plan/index.vue?macro=true";
import { default as _91sortOrder_93VEOFcWIJiQKEi5MkzN2MPaxGyFD7MMHNJJGBdKY_QN4Meta } from "/home/runner/work/evaluation/evaluation/pages/practice-topic-card/[topicId]/[sortOrder].vue?macro=true";
export default [
  {
    name: "end",
    path: "/end",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/end.vue")
  },
  {
    name: "tip",
    path: "/tip",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/tip.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/index.vue")
  },
  {
    name: "module",
    path: "/module",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/module.vue")
  },
  {
    name: "prepare",
    path: "/prepare",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/prepare.vue")
  },
  {
    name: "map",
    path: "/map",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/map/index.vue")
  },
  {
    name: "user-id",
    path: "/user/:id()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/user/[id].vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/chat/index.vue")
  },
  {
    name: "user",
    path: "/user",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/user/index.vue")
  },
  {
    name: "result-id",
    path: "/result/:id()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/result/[id].vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/unauthorized.vue")
  },
  {
    name: "reading",
    path: "/reading",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/reading/index.vue")
  },
  {
    name: "user-password",
    path: "/user/password",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/user/password.vue")
  },
  {
    name: "module-preview",
    path: "/module-preview",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/module-preview.vue")
  },
  {
    name: "practice",
    path: "/practice",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/practice/index.vue")
  },
  {
    name: "knowledge",
    path: "/knowledge",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/knowledge/index.vue")
  },
  {
    name: "information",
    path: "/information",
    meta: {"middleware":"chat"},
    component: () => import("/home/runner/work/evaluation/evaluation/pages/information/index.vue"),
    children: [
  {
    name: "information-index-resume",
    path: "resume",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/information/index/resume.vue")
  },
  {
    name: "information-index-confirm",
    path: "confirm",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/information/index/confirm.vue")
  },
  {
    name: "information-index-position",
    path: "position",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/information/index/position.vue")
  },
  {
    name: "information-index-inspection",
    path: "inspection",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/information/index/inspection.vue")
  }
]
  },
  {
    name: "user-feedback-id",
    path: "/user/feedback/:id()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/user/feedback/[id].vue")
  },
  {
    name: "practice-topic-id",
    path: "/practice-topic/:id()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/practice-topic/[id].vue")
  },
  {
    name: "result-complete-id",
    path: "/result/complete/:id()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/result/complete/[id].vue")
  },
  {
    name: "performanceInterview",
    path: "/performanceInterview",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/performanceInterview/index.vue")
  },
  {
    name: "potential-evaluations",
    path: "/potential-evaluations",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/potential-evaluations/index.vue")
  },
  {
    name: "crossPostingExperience",
    path: "/crossPostingExperience",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/crossPostingExperience/index.vue")
  },
  {
    name: "personal-development-plan",
    path: "/personal-development-plan",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/personal-development-plan/index.vue")
  },
  {
    name: "practice-topic-card-topicId-sortOrder",
    path: "/practice-topic-card/:topicId()/:sortOrder()",
    component: () => import("/home/runner/work/evaluation/evaluation/pages/practice-topic-card/[topicId]/[sortOrder].vue")
  }
]